// page-hatena-dx.jsx — DX支援（CRM・データ統合・AI・BI・プラグイン販売・既存システム刷新）ページ
// shell-d.jsx (HBLayout / HBSubHero / HBFooter) と variant-d.jsx (HBHeader / hbcp / fonts) を前提にする。

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE } = window;

  // legacy hatena theme（旧テーマ）の DX SVG 素材を活用。本番上の同 URL は redesign theme からも参照可能。
  const LEGACY_IMG = '/wp-content/themes/hatena/images/dx';

  // ---- Domain tiles : ヒーロー直下に「6 領域」を視覚的に並べるためのデータ ----
  // 旧 KPI strip（具体的件数を載せる）は、大手との数字比較を誘発するため撤去。
  // 代わりに 6 領域の "What we do" を簡潔なコード + JP 名 + 1 行サブで視覚化する。
  const DOMAIN_TILES = [
    { code:'CRM',    jp:'CRM 構築・データ統合',         sub:'Salesforce / kintone / Zoho / JustDB' },
    { code:'ACCT',   jp:'会計 SaaS 連携',               sub:'バクラク / freee / 勘定奉行 / マネフォ' },
    { code:'AI',     jp:'AI・自動化基盤',               sub:'プライベート LLM / N8N / Dify' },
    { code:'BI',     jp:'BI・データ可視化',             sub:'Power BI / Tableau / Looker' },
    { code:'RENEW',  jp:'既存システム乗り換え',         sub:'Access / FileMaker / VBA / 紙・FAX' },
    { code:'PLUGIN', jp:'プラグイン販売',               sub:'Salesforce / kintone' },
  ];

  // ---- Capability matrix : 6 領域 ----
  // 「kintone 導入支援」固定だった旧コピーから脱却し、はてなベース DX 事業部が
  // 実際にカバーする 6 領域を、境界を明示しながら定義する。
  const COVERAGE = [
    {
      num: '01',
      en: 'CRM & Data Integration',
      jp: 'CRM 構築・データ統合',
      d: 'Salesforce / kintone / Zoho / JustDB を中心に、リード→商談→受注→請求の各ステップを一画面化。既存業務システム（販売管理・基幹）との双方向連携も対応します。',
      stack: ['Salesforce', 'kintone', 'Zoho', 'JustDB'],
    },
    {
      num: '02',
      en: 'Accounting SaaS Connect',
      jp: '会計 SaaS 連携',
      d: '販売・営業データから会計ソフトへの自動仕訳、請求書発行→入金消込まで。バクラク / freee / 勘定奉行クラウド / マネーフォワードの API・iPaaS 連携の設計と運用を伴走します。',
      stack: ['バクラク', 'freee', '勘定奉行', 'マネーフォワード'],
    },
    {
      num: '03',
      en: 'AI & Automation',
      jp: 'AI・自動化基盤',
      d: 'PoC〜運用設計までを伴走。要件次第で、社外送信しないオンプレ／プライベート LLM 構成も設計可能です。N8N / Dify による業務 AI フロー組み込み、生成 AI × RPA まで対応します。',
      stack: ['オンプレ / プライベート LLM', 'N8N', 'Dify', 'AI × RPA'],
    },
    {
      num: '04',
      en: 'BI & Analytics',
      jp: 'BI・データ可視化基盤',
      d: 'バラバラな販売・在庫・会計データを DWH に集約し、経営ダッシュボードを構築。Power BI / Tableau / Looker Studio をビジネス要件に応じて使い分け、Snowflake / Databricks / ArcGIS は対象案件に応じて選定します。',
      stack: ['Power BI', 'Tableau', 'Looker Studio', 'Snowflake', 'Databricks', 'ArcGIS'],
    },
    {
      num: '05',
      en: 'System Renewal',
      jp: '既存システムからの乗り換え',
      d: 'Microsoft Access / FileMaker / VBA マクロ運用 / 古いオンプレ販売管理 / 紙・FAX 業務 / Lotus Notes ── 長年積み上げた業務ロジックを保ったまま、クラウド・SaaS・kintone へ段階的に移植します。「全部置き換え」ではなく「動かしながら移し替える」のが当社の特徴。',
      stack: ['Access 移行', 'FileMaker 移行', 'オンプレ→クラウド', 'VBA 継承', '紙・FAX デジタル化'],
    },
    {
      num: '06',
      en: 'Plugin Distribution',
      jp: 'プラグイン販売',
      d: '自社開発の Salesforce / kintone プラグインを販売。SES 工数管理・会計連携・帳票出力・在庫管理など、現場で必要だった機能をパッケージ提供。導入・カスタマイズ・運用サポートまで一貫対応。',
      stack: ['Salesforce プラグイン', 'kintone プラグイン', 'パッケージ販売', '導入支援'],
    },
  ];

  // ---- Use cases : legacy SVG 素材を活用した業務領域別ユースケース ----
  const USAGE = [
    { num:'01', en:'Management', jp:'経営管理',   img:`${LEGACY_IMG}/example_01.svg`, alt:'業績ダッシュボードのイラスト', d:'業績ダッシュボード作成、経営指標のリアルタイム可視化。会計・販売データを横断した一枚絵を経営会議の標準フォーマットに。' },
    { num:'02', en:'Sales',      jp:'営業管理',   img:`${LEGACY_IMG}/example_02.svg`, alt:'営業進捗管理のイラスト',     d:'顧客情報管理、営業進捗レポート、商談予実。SFA 運用 + 会計データとの突合で歩留まりの可視化まで。' },
    { num:'03', en:'Finance',    jp:'財務管理',   img:`${LEGACY_IMG}/example_03.svg`, alt:'請求書と資金繰りのイラスト',  d:'請求書作成・送付・回収管理、資金繰り表、CF 予測。会計 SaaS と販売管理を連携して月次クローズを高速化。' },
    { num:'04', en:'Automation', jp:'業務自動化', img:`${LEGACY_IMG}/example_04.svg`, alt:'業務自動化のイラスト',       d:'OCR / RPA / N8N / Dify との連携による業務効率化。手作業で月数十時間かかる集計・突合・台帳更新を自動ジョブに置き換え。' },
  ];

  // ---- Pricing plan : 「kintone」固有から DX 全般の伴走プランに汎用化 ----
  const PLANS = [
    { tag:'PLAN A', name:'新規導入プラン', d:'CRM / 会計 SaaS / BI / AI 基盤の未導入企業に対して、業務ヒアリング → 要件整理 → ツール選定 → 構築 → 定着支援までを一気通貫で対応。複数システムが絡む場合のスタックも設計します。' },
    { tag:'PLAN B', name:'既存環境改修プラン', d:'すでに使っているが煩雑になっている／属人化している環境を、再設計＋連携整理＋運用ガイド整備で立て直す。Access・古いオンプレ・スプレッドシート運用からの段階的移行もこちら。' },
  ];

  const OPTIONS = [
    'iPaaS / API 連携設計（freee / kintone / Salesforce / Slack / Notion）',
    'カスタムレポート・BIダッシュボード構築（Power BI / Tableau / Looker Studio）',
    'プライベート LLM / オンプレ AI サーバーの構築',
    'N8N / Dify による AI ワークフロー組み込み',
    'Salesforce / kintone プラグイン開発・販売',
    'セキュリティ強化（IP 制限・操作ログ・SSO・監査対応）',
    '管理者・利用者向けトレーニング、運用定着伴走',
  ];

  // ---- Related LPs : 関連 LP リスト（誇大数値は外し、機能ベースで一般化） ----
  const RELATED_LPS = [
    { url:`${HB_BASE}/finance-rebuild/`,         color:'#1F61AB', domain:'CF・財務再建',  label:'資金繰り改善・財務再建',  d:'公認会計士・税理士・FA の内製チームが、資金調達から CF 管理まで伴走します。' },
    { url:`${HB_BASE}/zeirishi-kintone/`,        color:'#0F4C81', domain:'業種別 CRM',    label:'税理士向け kintone 導入', d:'顧問先管理を事務所の「型」として標準化。引継ぎとレビュー工程を整理し、属人化を解消します。' },
    { url:`${HB_BASE}/manufacturing-bi/`,        color:'#3D4D5C', domain:'BI 基盤',       label:'製造業 統合 BI 基盤',     d:'生産・在庫・会計データを Power BI / Looker Studio で一画面に集約します。' },
    { url:`${HB_BASE}/freee-setup/`,             color:'#00838F', domain:'会計 SaaS',     label:'freee 会計 導入支援',     d:'要件定義から運用定着まで。「動く freee」を御社にフィットさせて立ち上げます。' },
    { url:`${HB_BASE}/sespkg/`,                  color:'#5B4FB5', domain:'業種パッケージ', label:'SES 特化型 kintone パッケージ', d:'工数突合・案件別収益管理・経費精算など SES 業務を一本化します。' },
    { url:`${HB_BASE}/accounting-dx/`,           color:'#0B6E55', domain:'経理 DX',       label:'経理 DX 完全版',           d:'月末に集中していた経理業務を、AI・自動化・SaaS 連携で月初に取り戻します。' },
    { url:`${HB_BASE}/e-learning-2/`,            color:'#0F8B5E', domain:'人材育成',      label:'DX 研修コンテンツ',        d:'生成 AI / CRM / BI / クラウド会計を 15 時間以上の動画で内製育成します。' },
    { url:`${HB_BASE}/construction-dx-package/`, color:'#D27418', domain:'業種パッケージ', label:'建設・工務店 DX',          d:'現場帳票・職人手配・原価管理を kintone × クラウドで再設計します。' },
    { url:`${HB_BASE}/ai-marketing-automation/`, color:'#A33DAC', domain:'AI 業務',        label:'AI マーケ自動化',          d:'広告運用・ROAS 最適化を生成 AI と SFA 連携で内製化します。' },
    { url:`${HB_BASE}/lp/ax-premium/`,           color:'#102A43', domain:'役員研修',      label:'AX Premium',               d:'経営層・幹部向け Advanced eXperience プログラム。' },
    { url:`${HB_BASE}/lp/ax-bpo/`,               color:'#1A3C5E', domain:'BPO',           label:'AX-BPO',                   d:'バックオフィス機能を業務ごと預けられる BPO + DX 一体プラン。' },
    { url:`${HB_BASE}/lp/kaikei-bugyou/`,        color:'#1F6FB2', domain:'会計 SaaS',     label:'勘定奉行クラウド導入',     d:'OBC 勘定奉行クラウドの要件定義・移行・運用伴走。' },
  ];

  const BLOG_TEASERS = [
    { tag:'kintone', txt:'kintone 導入の落とし穴と、回避策' },
    { tag:'freee',   txt:'freee × kintone の自動仕訳設計' },
    { tag:'AI',      txt:'プライベート LLM 導入の意思決定軸' },
    { tag:'BI',      txt:'Power BI と Tableau、選定基準の整理' },
  ];

  // ---- 4-Phase 支援フロー（Discover / Design / Build / Embed） ----
  // editorial 風の図解。各フェーズに italic serif の番号 + EN ラベル + JP 見出し
  // + 4 つの作業ステップ + 幾何モチーフ（circle / square / triangle / x-cross）を配置。
  const PHASES = [
    { num:'01', en:'Discover', jp:'要件定義',     motif:'circle',
      sub:'業務ヒアリング',
      steps:['業務ヒアリング', '現状棚卸し', '課題マッピング', 'スコープ合意'] },
    { num:'02', en:'Design',   jp:'設計',         motif:'square',
      sub:'データモデル設計',
      steps:['データモデル設計', 'ツール選定', '要件書化', '概算見積'] },
    { num:'03', en:'Build',    jp:'構築',         motif:'triangle',
      sub:'開発・移行',
      steps:['開発', 'テスト', 'データ移行', 'パイロット運用'] },
    { num:'04', en:'Embed',    jp:'定着・運用',   motif:'cross',
      sub:'運用伴走',
      steps:['利用者トレーニング', '運用ガイド', '改善 PDCA', '運用伴走'] },
  ];

  // ---- 業種別ソリューション 5 領域 ----
  // DX 事業部 / projects 配下に実プロジェクトが存在する 5 業種を厳選。
  const INDUSTRIES = [
    { code:'MED',   jp:'医療・在宅クリニック',
      issue:'レセプト → 経理 → 経営分析が分断、開業時の資金繰り不安',
      play:'freee for 医療 ＋ レセプト BPO ＋ kintone 業務基盤の 4 社協業パッケージ',
      stacks:['freee for 医療', 'プロアス', 'GOONSY', 'kintone'] },
    { code:'PRO',   jp:'士業（税理士・社労士）',
      issue:'MyKomon ほかレガシー業務、顧問先別ナレッジの属人化',
      play:'kintone 業務管理刷新 ＋ 生成 AI による議事録要約／RAG／決算チェッカー設計',
      stacks:['kintone', 'Gemini', 'Claude', 'MyKomon→kintone'] },
    { code:'EDU',   jp:'教育・人材（日本語学校／実習生）',
      issue:'実習生・留学生管理、Google Workspace 移行、freee 内製化',
      play:'GWS 共有ドライブ設計 ＋ freee 会計伴走 ＋ Gemini 活用、見積・請求・経費まで一気通貫',
      stacks:['Google Workspace', 'freee', 'kintone', 'Gemini'] },
    { code:'CONS',  jp:'建設・環境（太陽光・解体）',
      issue:'ARO（資産除去債務）・減価償却・見積変動の正確な再計算',
      play:'kintone 上で減価償却率・ARO・見積増減を再計算するロジック構築 ＋ 保守契約パッケージ',
      stacks:['kintone', 'freee', 'ARO 自動計算', '保守契約'] },
    { code:'RET',   jp:'小売・催事・販促',
      issue:'催事の特殊な収益構造、商談 → 受注 → 生産 → 会計の分断',
      play:'kintone × freee で「商談 → 受注 → 生産 → 会計」を統合、物産展運営・自販機オペも対応',
      stacks:['kintone', 'freee', '出店者管理', 'MD オペ'] },
  ];

  // ---- 導入事例 6 件（achievements CPT より、6 領域に 1 件ずつマッピング） ----
  const CASES = [
    { id:15429, domain:'CRM', title:'SES企業A社：転記ゼロで盤石なバックオフィス',
      excerpt:'営業から請求・入金まで分断していた業務を kintone × freee で一元化。二重入力・属人化を解消し、反社チェックも自動化。',
      thumb:'https://hatenabase.jp/wp-content/uploads/2025/12/Gemini_Generated_Image_iuznuaiuznuaiuzn-scaled.png',
      link:'https://hatenabase.jp/achievements/%e3%80%8c%e8%bb%a2%e8%a8%98%e4%bd%9c%e6%a5%ad%e3%82%bc%e3%83%ad%e3%80%8d%e3%81%a7%e7%b5%84%e7%b9%94%e6%8b%a1%e5%a4%a7%e3%81%ab%e5%82%99%e3%81%88%e3%82%8b%e3%80%82ses%e4%bc%81%e6%a5%ada%e7%a4%be/' },
    { id:15452, domain:'会計連携', title:'コンサルF社：kintone × freee でバックオフィス業務を再設計',
      excerpt:'勤怠・契約更新・請求書を kintone と freee で連携。月次でかかっていたバックオフィス業務を圧縮し、IPO 準備にも対応。',
      thumb:'https://hatenabase.jp/wp-content/uploads/2025/12/Gemini_Generated_Image_cm6lfgcm6lfgcm6l-scaled.png',
      link:'https://hatenabase.jp/achievements/%e5%b9%b4%e9%96%931200%e6%99%82%e9%96%93%e3%81%ae%e6%a5%ad%e5%8b%99%e5%89%8a%e6%b8%9b%ef%bc%81%e3%82%b3%e3%83%b3%e3%82%b5%e3%83%abf%e7%a4%be%e3%81%8ckintonexfreee%e9%80%a3%e6%90%ba%e3%81%a7/' },
    { id:15458, domain:'AI', title:'税理士法人A社：生成 AI で引継ぎ・提案書作成を効率化',
      excerpt:'顧客・案件・文書が分断していた税理士法人で kintone 統合基盤 ＋ 生成 AI を導入。引継ぎ時間と提案書作成時間を圧縮。',
      thumb:'https://hatenabase.jp/wp-content/uploads/2025/12/Gemini_Generated_Image_u7rs98u7rs98u7rs-scaled.png',
      link:'https://hatenabase.jp/achievements/%e5%bc%95%e7%b6%99%e3%81%8e%e6%99%82%e9%96%9350%e7%9f%ad%e7%b8%ae%e3%80%81%e6%8f%90%e6%a1%88%e6%9b%b8%e4%bd%9c%e6%88%90%e6%99%82%e9%96%93%e3%82%9260%e5%89%8a%e6%b8%9b%ef%bc%81-%e7%a8%8e%e7%90%86/' },
    { id:15447, domain:'BI', title:'製造業D社：生産・在庫・会計を統合した経営 BI 基盤',
      excerpt:'スプレッドシート分散の事業データと freee 会計データを統合。レポートを自動化し、リアルタイム経営判断を可能に。',
      thumb:'https://hatenabase.jp/wp-content/uploads/2025/12/Gemini_Generated_Image_3bmrss3bmrss3bmr-scaled.png',
      link:'https://hatenabase.jp/achievements/%e7%94%9f%e7%94%a3%e3%83%bb%e5%9c%a8%e5%ba%ab%e3%83%bb%e4%bc%9a%e8%a8%88%e3%83%87%e3%83%bc%e3%82%bf%e3%81%8c%e3%83%90%e3%83%a9%e3%83%90%e3%83%a9%e3%81%a7%e5%88%86%e6%9e%90%e5%9b%b0%e9%9b%a3/' },
    { id:15435, domain:'乗り換え', title:'IT人材H社：脱 Access ＋ kintone 刷新で業務を再設計',
      excerpt:'属人化していた Access 内製ツールを kintone に刷新。請求から会計連携までを再設計し、月次処理を大幅に短縮。',
      thumb:'https://hatenabase.jp/wp-content/uploads/2025/12/Gemini_Generated_Image_3mvx3q3mvx3q3mvx-scaled.png',
      link:'https://hatenabase.jp/achievements/%e6%9c%88%e6%ac%a1%e5%87%a6%e7%90%86%e6%99%82%e9%96%93%e3%82%9270%e5%89%8a%e6%b8%9b%ef%bc%81it%e3%83%bb%e4%ba%ba%e6%9d%90%e3%82%b5%e3%83%bc%e3%83%93%e3%82%b9h%e7%a4%be%e3%81%8c%e5%ae%9f%e7%8f%be/' },
    { id:15875, domain:'プラグイン', title:'【極み/第一回】kintone × freee で築く経営プラットフォーム',
      excerpt:'顧客登録から利益率可視化までを kintone と freee で循環設計。複数社の導入知見を凝縮した DX パッケージ解説。',
      thumb:'https://hatenabase.jp/wp-content/uploads/2026/01/Gemini_Generated_Image_si5gvgsi5gvgsi5g-scaled.png',
      link:'https://hatenabase.jp/achievements/%e3%80%90%e6%a5%b5%e3%81%bf-%e7%ac%ac%e4%b8%80%e5%9b%9e%e3%80%91kintone%e5%be%b9%e5%ba%95%e8%a7%a3%e8%aa%ac%ef%bc%9a%e7%b5%8c%e5%96%b6%e3%82%92%e6%94%af%e3%81%88%e3%82%8b%e6%9c%80%e5%bc%b7%e3%81%ae/' },
  ];

  // ---- セミナー・ウェビナー（最新 6 件） ----
  const SEMINARS = [
    { date:'2025-12-03', title:'【登壇のお知らせ】12/3(水) 税理士法人松本様・freee様との共催セミナーに代表 世戸口が登壇します',
      mode:'オンライン', theme:'税理士法人松本 × freee × はてなベース 3 社共催。事務所の業務基盤構築',
      url:'https://hatenabase.jp/news/%e3%80%90%e7%99%bb%e5%a3%87%e6%83%85%e5%a0%b1%e3%80%9112-3%e6%b0%b4-%e7%a8%8e%e7%90%86%e5%a3%ab%e6%b3%95%e4%ba%ba%e6%9d%be%e6%9c%ac%e6%a7%98%e3%83%bbfreee%e6%a7%98%e3%81%a8%e3%81%ae%e5%85%b1/' },
    { date:'2025-11-21', title:'【セミナー登壇のお知らせ】弊社代表世戸口が「freee人材」育成セミナーに登壇します。',
      mode:'オンライン', theme:'DIGITAL BASE × freee 共催。クラウド会計 × DX 人材育成',
      url:'https://hatenabase.jp/news/%e3%80%90%e3%82%bb%e3%83%9f%e3%83%8a%e3%83%bc%e7%99%bb%e5%a3%87%e3%81%ae%e3%81%8a%e7%9f%a5%e3%82%89%e3%81%9b%e3%80%91%e5%bc%8a%e7%a4%be%e4%bb%a3%e8%a1%a8%e4%b8%96%e6%88%b8%e5%8f%a3%e3%81%8c%e3%80%8cfr/' },
    { date:'2025-10-27', title:'【イベント登壇のお知らせ】代表世戸口が「CPAナビコミ」主催イベントに登壇いたしました',
      mode:'オフライン', theme:'公認会計士 × テクノロジー。CRM・会計 BI で顧問先のアナログ業務を IT 化',
      url:'https://hatenabase.jp/news/%e3%80%90%e3%82%a4%e3%83%99%e3%83%b3%e3%83%88%e7%99%bb%e5%a3%87%e3%81%ae%e3%81%8a%e7%9f%a5%e3%82%89%e3%81%9b%e3%80%91%e4%bb%a3%e8%a1%a8%e4%b8%96%e6%88%b8%e5%8f%a3%e3%81%8c%e3%80%8ccpa%e3%83%8a/' },
    { date:'2025-06-27', title:'【無料AIセミナー/1h】明日、あなたの仕事が、劇的に変わる。 AI活用による業務自動化・効率化 実践講座',
      mode:'オンライン', theme:'生成 AI で資料作成・議事録・情報収集を圧縮',
      url:'https://hatenabase.jp/blog/%e3%80%90%e7%84%a1%e6%96%99ai%e3%82%bb%e3%83%9f%e3%83%8a%e3%83%bc-1h%e3%80%91%e6%98%8e%e6%97%a5%e3%80%81%e3%81%82%e3%81%aa%e3%81%9f%e3%81%ae%e4%bb%95%e4%ba%8b%e3%81%8c%e3%80%81%e5%8a%87%e7%9a%84/' },
    { date:'2025-06-23', title:'株式会社ストランダー様との共催セミナー「事例から学ぶ！生成AIによる攻めのバックオフィス構築術」開催のお知らせ',
      mode:'オンライン', theme:'ストランダー 共催。会計・財務・データ活用・人事・CS の生成 AI 実装',
      url:'https://hatenabase.jp/news/%e6%a0%aa%e5%bc%8f%e4%bc%9a%e7%a4%be%e3%82%b9%e3%83%88%e3%83%a9%e3%83%b3%e3%83%80%e3%83%bc%e6%a7%98%e3%81%a8%e3%81%ae%e5%85%b1%e5%82%ac/' },
    { date:'2024-01-01', title:'kintoneを活用したDXの始め方を解説するオンラインセミナーを株式会社SoLaboと開催します',
      mode:'オンライン', theme:'SoLabo 共催。中小企業向け kintone DX 入門',
      url:'https://hatenabase.jp/news/kintone%e3%82%92%e6%b4%bb%e7%94%a8%e3%81%97%e3%81%9fdx%e3%81%ae%e5%a7%8b%e3%82%81%e6%96%b9/' },
  ];

  // 幾何モチーフ SVG（フェーズ図のアクセント）
  function PhaseMotif({ kind, color, size = 28 }) {
    const s = size;
    if (kind === 'circle')   return <svg width={s} height={s} viewBox="0 0 28 28" aria-hidden="true" focusable="false"><circle cx="14" cy="14" r="11" fill="none" stroke={color} strokeWidth="1.4"/></svg>;
    if (kind === 'square')   return <svg width={s} height={s} viewBox="0 0 28 28" aria-hidden="true" focusable="false"><rect x="4" y="4" width="20" height="20" fill="none" stroke={color} strokeWidth="1.4"/></svg>;
    if (kind === 'triangle') return <svg width={s} height={s} viewBox="0 0 28 28" aria-hidden="true" focusable="false"><polygon points="14,4 25,24 3,24" fill="none" stroke={color} strokeWidth="1.4"/></svg>;
    if (kind === 'cross')    return <svg width={s} height={s} viewBox="0 0 28 28" aria-hidden="true" focusable="false"><line x1="5" y1="5" x2="23" y2="23" stroke={color} strokeWidth="1.4"/><line x1="23" y1="5" x2="5" y2="23" stroke={color} strokeWidth="1.4"/></svg>;
    return null;
  }

  function HatenaDxPage() {
    return (
      <HBLayout>
        {/* page 専用のレスポンシブ / インタラクション CSS */}
        <style>{`
          .hb-dx-hero-strip { background:${hbcp.blueGhost}; border-bottom:1px solid ${hbcp.line}; position:relative; overflow:hidden; }
          .hb-dx-hero-strip-inner { max-width:1280px; margin:0 auto; padding:56px 32px 64px; position:relative; z-index:1; }
          .hb-dx-hero-strip-bg { position:absolute; inset:0; pointer-events:none; opacity:.5; }
          .hb-dx-hero-eyebrow { display:flex; align-items:baseline; gap:14px; margin-bottom:24px; }
          .hb-dx-hero-eyebrow-en { font-family:${fontENSans}; font-size:10px; letter-spacing:.32em; color:${hbcp.blue}; font-weight:700; text-transform:uppercase; }
          .hb-dx-hero-eyebrow-jp { font-family:${fontJP}; font-size:13px; color:${hbcp.inkSoft}; }
          .hb-dx-domain-grid { display:grid; grid-template-columns:repeat(3, 1fr); gap:14px; }
          .hb-dx-domain-tile { background:#fff; border:1px solid ${hbcp.line}; padding:22px 22px 20px; position:relative; transition:border-color .18s ease, transform .18s ease, box-shadow .18s ease; }
          .hb-dx-domain-tile:hover { border-color:${hbcp.blue}; transform:translateY(-2px); box-shadow:0 6px 18px rgba(31,97,171,.08); }
          .hb-dx-domain-tile-code { font-family:${fontENSans}; font-size:10px; letter-spacing:.28em; color:${hbcp.blue}; font-weight:700; margin-bottom:10px; text-transform:uppercase; }
          .hb-dx-domain-tile-jp { font-family:${fontJP}; font-weight:700; font-size:16px; line-height:1.45; letter-spacing:.04em; color:${hbcp.ink}; margin:0 0 8px; }
          .hb-dx-domain-tile-sub { font-family:${fontMono}; font-size:11px; line-height:1.55; color:${hbcp.inkLight}; margin:0; }
          .hb-dx-h2 { font-family:${fontJP}; font-weight:800; font-size:28px; line-height:1.4; letter-spacing:.04em; margin:0 0 12px; color:${hbcp.ink}; }
          .hb-dx-lead { font-size:14px; line-height:1.85; color:${hbcp.inkSoft}; max-width:780px; margin:0 0 32px; }
          .hb-dx-cov-grid { display:grid; grid-template-columns:repeat(2, 1fr); gap:0; border-top:1px solid ${hbcp.line}; border-left:1px solid ${hbcp.line}; }
          .hb-dx-cov-cell { padding:36px 32px; border-right:1px solid ${hbcp.line}; border-bottom:1px solid ${hbcp.line}; background:#fff; }
          .hb-dx-use-grid { display:grid; grid-template-columns:repeat(2, 1fr); gap:0; border-top:1px solid ${hbcp.line}; border-left:1px solid ${hbcp.line}; background:#fff; }
          .hb-dx-use-cell { padding:40px 32px; border-right:1px solid ${hbcp.line}; border-bottom:1px solid ${hbcp.line}; display:grid; grid-template-columns:1fr 200px; gap:24px; align-items:center; }
          .hb-dx-pricing-grid { display:grid; grid-template-columns:repeat(2, 1fr); gap:24px; }
          .hb-dx-options-list { margin:0; padding:0; list-style:none; display:grid; grid-template-columns:1fr 1fr; gap:10px 24px; }
          .hb-dx-rel-grid { display:grid; grid-template-columns:repeat(auto-fill, minmax(280px, 1fr)); gap:18px; }
          .hb-dx-rel-card { display:flex; flex-direction:column; text-decoration:none; color:${hbcp.ink}; background:#fff; border:1px solid ${hbcp.line}; padding:24px 22px; min-height:170px; position:relative; transition:transform .18s ease, box-shadow .18s ease, border-color .18s ease; }
          .hb-dx-rel-card:hover, .hb-dx-rel-card:focus-visible { transform:translateY(-2px); box-shadow:0 8px 24px rgba(31,97,171,.12); border-color:${hbcp.blueLight}; outline:none; }
          .hb-dx-rel-domain { font-family:${fontENSans}; font-size:9.5px; letter-spacing:.22em; color:${hbcp.inkLight}; font-weight:700; text-transform:uppercase; margin-bottom:6px; }
          .hb-dx-blog-grid { display:grid; grid-template-columns:1.2fr 1fr; gap:64px; align-items:flex-end; }
          .hb-dx-cta-grid { display:grid; grid-template-columns:1.4fr 1fr; gap:64px; align-items:flex-end; }
          /* ----- 4-Phase 図 ----- */
          .hb-dx-phases-wrap { display:grid; grid-template-columns:repeat(4, 1fr); gap:0; border-top:1px solid ${hbcp.line}; border-left:1px solid ${hbcp.line}; background:#fff; position:relative; }
          .hb-dx-phase-cell { padding:36px 28px 32px; border-right:1px solid ${hbcp.line}; border-bottom:1px solid ${hbcp.line}; position:relative; }
          .hb-dx-phase-num { font-family:${fontEN}; font-weight:300; font-size:64px; color:${hbcp.blue}; line-height:1; margin-bottom:18px; display:flex; align-items:center; justify-content:space-between; }
          .hb-dx-phase-en { font-family:${fontENSans}; font-size:10px; letter-spacing:.32em; color:${hbcp.blue}; font-weight:700; margin-bottom:8px; text-transform:uppercase; }
          .hb-dx-phase-jp { font-family:${fontJP}; font-weight:800; font-size:20px; line-height:1.4; letter-spacing:.04em; color:${hbcp.ink}; margin:0 0 16px; }
          .hb-dx-phase-steps { margin:0; padding:0; list-style:none; }
          .hb-dx-phase-step { font-family:${fontJP}; font-size:13px; line-height:1.7; color:${hbcp.inkSoft}; padding:6px 0 6px 16px; border-top:1px solid ${hbcp.line}; position:relative; }
          .hb-dx-phase-step:first-child { border-top:0; }
          .hb-dx-phase-step::before { content:''; position:absolute; left:0; top:14px; width:8px; height:1px; background:${hbcp.blue}; }
          .hb-dx-phase-arrow { position:absolute; top:60px; right:-9px; width:18px; height:18px; background:#fff; border:1px solid ${hbcp.line}; border-bottom:0; border-left:0; transform:rotate(45deg); z-index:2; }
          .hb-dx-phase-cell:last-child .hb-dx-phase-arrow { display:none; }
          /* ----- 業種別ソリューション ----- */
          .hb-dx-ind-grid { display:grid; grid-template-columns:repeat(2, 1fr); gap:16px; }
          .hb-dx-ind-card { padding:30px 28px; background:#fff; border:1px solid ${hbcp.line}; border-left:3px solid ${hbcp.blue}; position:relative; transition:transform .18s ease, box-shadow .18s ease; }
          .hb-dx-ind-card:hover { transform:translateY(-2px); box-shadow:0 8px 24px rgba(31,97,171,.08); }
          .hb-dx-ind-code { font-family:${fontENSans}; font-size:10px; letter-spacing:.32em; color:${hbcp.blueDeep}; font-weight:700; margin-bottom:8px; text-transform:uppercase; }
          .hb-dx-ind-name { font-family:${fontJP}; font-weight:800; font-size:18px; letter-spacing:.04em; color:${hbcp.ink}; margin:0 0 14px; }
          .hb-dx-ind-row { display:flex; gap:10px; font-size:13px; line-height:1.85; color:${hbcp.inkSoft}; margin-bottom:8px; }
          .hb-dx-ind-row b { font-family:${fontENSans}; font-size:9px; letter-spacing:.24em; color:${hbcp.blue}; font-weight:700; min-width:54px; padding-top:4px; }
          .hb-dx-ind-stacks { display:flex; flex-wrap:wrap; gap:6px; margin-top:14px; }
          .hb-dx-ind-stack { font-family:${fontMono}; font-size:10.5px; color:${hbcp.blue}; padding:3px 9px; border:1px solid ${hbcp.blueLight}; background:${hbcp.blueGhost}; }
          /* ----- Case studies ----- */
          .hb-dx-case-grid { display:grid; grid-template-columns:repeat(3, 1fr); gap:18px; }
          .hb-dx-case-card { display:flex; flex-direction:column; text-decoration:none; color:${hbcp.ink}; background:#fff; border:1px solid ${hbcp.line}; overflow:hidden; transition:transform .18s ease, box-shadow .18s ease, border-color .18s ease; }
          .hb-dx-case-card:hover, .hb-dx-case-card:focus-visible { transform:translateY(-2px); box-shadow:0 10px 28px rgba(31,97,171,.12); border-color:${hbcp.blueLight}; outline:none; }
          .hb-dx-case-thumb { aspect-ratio:16/9; overflow:hidden; background:${hbcp.paperWarm}; }
          .hb-dx-case-thumb img { width:100%; height:100%; object-fit:cover; display:block; }
          .hb-dx-case-body { padding:20px 22px; display:flex; flex-direction:column; flex:1; }
          .hb-dx-case-domain { display:inline-block; align-self:flex-start; font-family:${fontENSans}; font-size:9px; letter-spacing:.22em; color:${hbcp.blue}; font-weight:700; padding:3px 10px; border:1px solid ${hbcp.blueLight}; background:${hbcp.blueGhost}; text-transform:uppercase; margin-bottom:10px; }
          .hb-dx-case-title { font-family:${fontJP}; font-weight:700; font-size:15px; line-height:1.5; margin:0 0 8px; color:${hbcp.ink}; }
          .hb-dx-case-excerpt { font-size:12.5px; line-height:1.75; color:${hbcp.inkSoft}; margin:0 0 14px; flex:1; }
          .hb-dx-case-more { font-family:${fontENSans}; font-size:11px; font-weight:700; letter-spacing:.06em; color:${hbcp.blue}; border-bottom:1px solid ${hbcp.blue}; padding-bottom:2px; align-self:flex-start; }
          /* ----- Seminar list ----- */
          .hb-dx-sem-list { border-top:1px solid ${hbcp.line}; background:#fff; }
          .hb-dx-sem-row { display:grid; grid-template-columns:140px 110px 1fr 32px; gap:24px; align-items:center; padding:22px 28px; border-bottom:1px solid ${hbcp.line}; text-decoration:none; color:${hbcp.ink}; transition:background .18s ease; }
          .hb-dx-sem-row:hover, .hb-dx-sem-row:focus-visible { background:${hbcp.paperWarm}; outline:none; }
          .hb-dx-sem-date { font-family:${fontEN}; font-size:18px; color:${hbcp.blueDeep}; letter-spacing:.04em; }
          .hb-dx-sem-mode { font-family:${fontENSans}; font-size:10px; letter-spacing:.24em; color:${hbcp.blue}; font-weight:700; padding:4px 0 4px 0; border-left:2px solid ${hbcp.blue}; padding-left:10px; }
          .hb-dx-sem-body { display:flex; flex-direction:column; gap:4px; min-width:0; }
          .hb-dx-sem-title { font-family:${fontJP}; font-weight:700; font-size:14.5px; line-height:1.5; color:${hbcp.ink}; }
          .hb-dx-sem-theme { font-size:12px; line-height:1.65; color:${hbcp.inkLight}; }
          .hb-dx-sem-arrow { font-family:${fontEN}; font-size:18px; color:${hbcp.inkLight}; justify-self:end; }
          @media (max-width: 900px) {
            .hb-dx-hero-strip-inner { padding:36px 22px 40px; }
            .hb-dx-domain-grid { grid-template-columns:repeat(2, 1fr); gap:10px; }
            .hb-dx-h2 { font-size:24px; }
            .hb-dx-cov-grid, .hb-dx-use-grid, .hb-dx-pricing-grid, .hb-dx-blog-grid, .hb-dx-cta-grid { grid-template-columns:1fr !important; }
            .hb-dx-use-cell { grid-template-columns:1fr !important; gap:20px; padding:32px 22px; }
            .hb-dx-cov-cell { padding:28px 22px; }
            .hb-dx-options-list { grid-template-columns:1fr !important; }
            .hb-dx-blog-grid, .hb-dx-cta-grid { gap:32px; }
            .hb-dx-phases-wrap { grid-template-columns:1fr; }
            .hb-dx-phase-arrow { top:auto; bottom:-9px; right:50%; transform:translateX(50%) rotate(135deg); }
            .hb-dx-phase-cell { padding:28px 22px 26px; }
            .hb-dx-phase-num { font-size:48px; }
            .hb-dx-ind-grid { grid-template-columns:1fr; }
            .hb-dx-case-grid { grid-template-columns:1fr; gap:14px; }
            .hb-dx-sem-row { grid-template-columns:90px 90px 1fr; gap:14px; padding:18px 20px; }
            .hb-dx-sem-arrow { display:none; }
          }
          @media (max-width: 560px) {
            .hb-dx-domain-grid { grid-template-columns:1fr; }
            .hb-dx-sem-row { grid-template-columns:1fr; gap:6px; padding:18px 18px; }
            .hb-dx-sem-mode { padding-left:0; border-left:0; border-top:2px solid ${hbcp.blue}; padding-top:6px; }
          }
        `}</style>

        <HBSubHero
          crumb={`Service / DX 支援`}
          en="DX Support"
          jp={<span>CRMツールからクラウド会計までの<br/><span style={{color:hbcp.blue}}>データの流れを一元化</span>するDX支援</span>}
          tag={'Building the operating system of business.'}
          lead={'CRM・会計 SaaS 連携・AI／自動化・BI・既存システム乗り換え・プラグイン販売の 6 領域をカバー。要件定義から運用定着まで、内製チームが一気通貫で伴走します。'}
        />

        {/* ===== Hero strip : 6 領域を視覚的に提示するタイル ===== */}
        <section className="hb-dx-hero-strip" aria-label="対応領域">
          <svg className="hb-dx-hero-strip-bg" viewBox="0 0 1280 360" preserveAspectRatio="xMaxYMid slice" aria-hidden="true" focusable="false">
            <g stroke={hbcp.blueLight} strokeWidth="1" fill="none" opacity="0.85">
              {[...Array(12)].map((_,i)=>(<circle key={i} cx="1180" cy="180" r={22 + i*22} />))}
            </g>
            <g stroke={hbcp.blueLight} strokeWidth="1" fill="none" opacity="0.35">
              {[...Array(8)].map((_,i)=>(<line key={i} x1="40" y1={40 + i*40} x2="320" y2={40 + i*40} />))}
            </g>
          </svg>
          <div className="hb-dx-hero-strip-inner">
            <div className="hb-dx-hero-eyebrow">
              <span className="hb-dx-hero-eyebrow-en">— What we cover</span>
              <span className="hb-dx-hero-eyebrow-jp">DX 事業部がカバーする 6 領域</span>
            </div>
            <div className="hb-dx-domain-grid">
              {DOMAIN_TILES.map(t => (
                <div key={t.code} className="hb-dx-domain-tile">
                  <div className="hb-dx-domain-tile-code">{t.code}</div>
                  <h3 className="hb-dx-domain-tile-jp">{t.jp}</h3>
                  <p className="hb-dx-domain-tile-sub">{t.sub}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== Capability matrix : 6 領域 ===== */}
        <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}} aria-labelledby="dx-capability-heading">
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Capability</span>
              <span className="hb-section-head-jp">DX 事業部が伴走する 6 領域</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>DOMAINS</span>
            </div>
            <h2 id="dx-capability-heading" className="hb-dx-h2">CRM・会計・AI・BI・既存システム刷新・プラグインの 6 領域</h2>
            <p className="hb-dx-lead">単一ベンダー固定ではなく、要件と既存資産に応じて最適なスタックを選定します。各領域の到達点（どこまで御社で巻き取れるか）を最初に擦り合わせ、無理のないスコープで進めます。</p>
            <div className="hb-dx-cov-grid">
              {COVERAGE.map(c => (
                <div key={c.num} className="hb-dx-cov-cell">
                  <div style={{display:'flex', alignItems:'baseline', gap:14, marginBottom:14}}>
                    <span style={{fontFamily:fontEN, fontWeight:300, fontSize:36, color:hbcp.blue, lineHeight:1}}>{c.num}</span>
                    <span style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.28em', color:hbcp.inkLight}}>{c.en}</span>
                  </div>
                  <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:22, lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 12px'}}>{c.jp}</h3>
                  <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 16px'}}>{c.d}</p>
                  <div style={{display:'flex', flexWrap:'wrap', gap:6}}>
                    {c.stack.map(s => (
                      <span key={s} style={{fontFamily:fontMono, fontSize:11, color:hbcp.blue, padding:'4px 10px', border:`1px solid ${hbcp.blueLight}`, background:hbcp.blueGhost}}>{s}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== Support Phases : 4-Phase 支援フロー ===== */}
        <section style={{padding:'96px 32px', background:hbcp.paperWarm, borderBottom:`1px solid ${hbcp.line}`}} aria-labelledby="dx-phases-heading">
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">How we work</span>
              <span className="hb-section-head-jp">支援フェーズ</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>4 PHASES</span>
            </div>
            <h2 id="dx-phases-heading" className="hb-dx-h2">ご相談から運用定着まで、4 フェーズで伴走します</h2>
            <p className="hb-dx-lead">DX は導入して終わりではありません。各フェーズで「次に何をやるか」「誰が何を決めるか」を明確にしながら、地に足のついた順序で進めます。フェーズの境界で進捗・スコープを再確認し、無理な巻き取りや過大投資を防ぎます。</p>
            <div className="hb-dx-phases-wrap" role="list">
              {PHASES.map((p, idx) => (
                <div key={p.num} className="hb-dx-phase-cell" role="listitem">
                  <div className="hb-dx-phase-num">
                    <span>{p.num}</span>
                    <PhaseMotif kind={p.motif} color={hbcp.blue} size={28}/>
                  </div>
                  <div className="hb-dx-phase-en">{p.en}</div>
                  <h3 className="hb-dx-phase-jp">{p.jp}</h3>
                  <ul className="hb-dx-phase-steps">
                    {p.steps.map(s => (<li key={s} className="hb-dx-phase-step">{s}</li>))}
                  </ul>
                  {idx < PHASES.length - 1 && <span className="hb-dx-phase-arrow" aria-hidden="true"/>}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== Usage example : legacy SVG 素材活用 ===== */}
        <section style={{padding:'96px 32px', background:hbcp.paper}} aria-labelledby="dx-usage-heading">
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Usage example</span>
              <span className="hb-section-head-jp">業務領域別のユースケース</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>BUSINESS PATTERNS</span>
            </div>
            <h2 id="dx-usage-heading" className="hb-dx-h2">経営・営業・財務・自動化、4 つの業務シーン</h2>
            <p className="hb-dx-lead">特定の業界・規模に依らず、バックオフィス全般で頻出する 4 つのシーンを起点に、御社の業務に合わせて再構成します。</p>
            <div className="hb-dx-use-grid">
              {USAGE.map(u => (
                <div key={u.num} className="hb-dx-use-cell">
                  <div>
                    <div style={{display:'flex', alignItems:'baseline', gap:14, marginBottom:18}}>
                      <span style={{fontFamily:fontEN, fontWeight:300, fontSize:36, color:hbcp.blue, lineHeight:1}}>{u.num}</span>
                      <span style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.28em', color:hbcp.inkLight}}>{u.en}</span>
                    </div>
                    <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:24, lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 14px'}}>{u.jp}</h3>
                    <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:0}}>{u.d}</p>
                  </div>
                  {u.img && (
                    <img src={u.img} alt={u.alt} loading="lazy" style={{width:'100%', height:'auto', display:'block', maxWidth:200}}/>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== Industry Solutions : 業種別 ===== */}
        <section style={{padding:'96px 32px', background:hbcp.white, borderTop:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`}} aria-labelledby="dx-industry-heading">
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Industry solutions</span>
              <span className="hb-section-head-jp">業種別ソリューション</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>BY INDUSTRY</span>
            </div>
            <h2 id="dx-industry-heading" className="hb-dx-h2">業種特有の論点を踏まえて設計します</h2>
            <p className="hb-dx-lead">同じ「経理 DX」「CRM 構築」でも、業界ごとに勘所や監査・税務上の論点は大きく異なります。当社が実際にプロジェクトを担当している領域を中心に、業種別の打ち手を例示します。</p>
            <div className="hb-dx-ind-grid">
              {INDUSTRIES.map(ind => (
                <div key={ind.code} className="hb-dx-ind-card">
                  <div className="hb-dx-ind-code">{ind.code}</div>
                  <h3 className="hb-dx-ind-name">{ind.jp}</h3>
                  <div className="hb-dx-ind-row"><b>課題</b><span>{ind.issue}</span></div>
                  <div className="hb-dx-ind-row"><b>打ち手</b><span>{ind.play}</span></div>
                  <div className="hb-dx-ind-stacks">
                    {ind.stacks.map(s => <span key={s} className="hb-dx-ind-stack">{s}</span>)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== Case studies : 6 件の導入事例 ===== */}
        <section style={{padding:'96px 32px', background:hbcp.paper}} aria-labelledby="dx-cases-heading">
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Case studies</span>
              <span className="hb-section-head-jp">導入事例</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>SELECTED</span>
            </div>
            <h2 id="dx-cases-heading" className="hb-dx-h2">6 領域からの代表的な事例</h2>
            <p className="hb-dx-lead">各事例の詳細（背景・打ち手・成果）はリンク先の Achievements でご覧いただけます。</p>
            <div className="hb-dx-case-grid">
              {CASES.map(c => (
                <a key={c.id} href={c.link} className="hb-dx-case-card">
                  <div className="hb-dx-case-thumb">
                    <img src={c.thumb} alt={c.title} loading="lazy"/>
                  </div>
                  <div className="hb-dx-case-body">
                    <span className="hb-dx-case-domain">{c.domain}</span>
                    <h3 className="hb-dx-case-title">{c.title}</h3>
                    <p className="hb-dx-case-excerpt">{c.excerpt}</p>
                    <span className="hb-dx-case-more">事例を読む →</span>
                  </div>
                </a>
              ))}
            </div>
            <div style={{marginTop:32, textAlign:'center'}}>
              <a href={`${HB_BASE}/achievements`} style={{display:'inline-flex', alignItems:'center', gap:8, padding:'14px 28px', background:'#fff', color:hbcp.ink, border:`1px solid ${hbcp.ink}`, textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:600}}>
                すべての事例を見る <span style={{fontFamily:fontEN}} aria-hidden="true">↗</span>
              </a>
            </div>
          </div>
        </section>

        {/* ===== Pricing plan ===== */}
        <section style={{padding:'96px 32px', background:hbcp.white}} aria-labelledby="dx-pricing-heading">
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Pricing plan</span>
              <span className="hb-section-head-jp">DX 支援の料金形態</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>BASE PLANS</span>
            </div>
            <h2 id="dx-pricing-heading" className="hb-dx-h2">スタート時の状態に合わせて 2 プラン + オプション</h2>
            <p className="hb-dx-lead">「これから入れる」か「すでに動いている環境を立て直す」かで初動が大きく変わるため、入口を 2 つに分けています。最終的なお見積もりは要件ヒアリング後に提示します。</p>
            <div className="hb-dx-pricing-grid">
              {PLANS.map(p => (
                <div key={p.tag} style={{padding:'40px 32px', background:hbcp.paper, border:`1px solid ${hbcp.line}`}}>
                  <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', color:hbcp.blue, marginBottom:14}}>{p.tag}</div>
                  <h3 style={{fontFamily:fontJP, fontWeight:800, fontSize:26, letterSpacing:'.04em', margin:'0 0 14px'}}>{p.name}</h3>
                  <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:0}}>{p.d}</p>
                </div>
              ))}
            </div>
            <div style={{marginTop:32, padding:'32px', background:hbcp.paper, border:`1px solid ${hbcp.line}`}}>
              <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.32em', color:hbcp.blue, marginBottom:18}}>OPTIONS</div>
              <ul className="hb-dx-options-list">
                {OPTIONS.map(o => (
                  <li key={o} style={{display:'flex', alignItems:'flex-start', gap:10, fontSize:14, color:hbcp.ink, fontWeight:500}}>
                    <span style={{display:'inline-block', width:6, height:6, marginTop:6, background:hbcp.blue, flex:'0 0 6px'}} aria-hidden="true"/>
                    <span>{o}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div style={{marginTop:32, display:'flex', flexWrap:'wrap', gap:14}}>
              <a href={`${HB_BASE}/document-request`} style={{padding:'14px 26px', background:hbcp.blue, color:'#fff', textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:700}}>
                見積もりシミュレーションをする <span style={{fontFamily:fontEN}}>→</span>
              </a>
              <a href={`${HB_BASE}/contact/?type=ax-dx`} style={{padding:'14px 26px', background:'transparent', color:hbcp.ink, border:`1px solid ${hbcp.ink}`, textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:600}}>
                専門家に無料で相談する <span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>

        {/* ===== Related LP grid ===== */}
        <section style={{padding:'96px 32px', background:hbcp.paper, borderTop:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`}} aria-labelledby="dx-related-heading">
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Related pages</span>
              <span id="dx-related-heading" className="hb-section-head-jp">テーマ別のページ</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>BY THEME</span>
            </div>
            <p className="hb-dx-lead">具体的なユースケース・料金イメージ・導入事例は各ページをご覧ください。各カードのドメイン表示は、上の 6 領域のうちどこに紐づくかの目印です。</p>
            <div className="hb-dx-rel-grid">
              {RELATED_LPS.map(lp => (
                <a key={lp.url} href={lp.url} className="hb-dx-rel-card">
                  <span style={{display:'inline-block', width:30, height:3, background:lp.color, marginBottom:14}} aria-hidden="true"/>
                  <span className="hb-dx-rel-domain">{lp.domain}</span>
                  <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:15, lineHeight:1.5, margin:'0 0 10px', color:hbcp.ink}}>{lp.label}</h3>
                  <p style={{fontSize:12.5, lineHeight:1.75, color:hbcp.inkSoft, margin:'0 0 16px', flex:1}}>{lp.d}</p>
                  <span style={{fontSize:11, fontFamily:fontENSans, fontWeight:700, letterSpacing:'.06em', color:lp.color, borderBottom:`1px solid ${lp.color}`, paddingBottom:2, alignSelf:'flex-start'}}>
                    詳しく見る →
                  </span>
                </a>
              ))}
            </div>
            <div style={{marginTop:32, textAlign:'center'}}>
              <a href={`${HB_BASE}/lp/`} style={{display:'inline-flex', alignItems:'center', gap:8, padding:'14px 28px', background:'#fff', color:hbcp.ink, border:`1px solid ${hbcp.ink}`, textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:600}}>
                テーマ別のページを一覧で見る <span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>

        {/* ===== Seminars : 過去開催のセミナー・ウェビナー ===== */}
        <section style={{padding:'96px 32px', background:hbcp.white}} aria-labelledby="dx-seminars-heading">
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Seminars &amp; Events</span>
              <span className="hb-section-head-jp">セミナー・ウェビナー</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>RECENT</span>
            </div>
            <h2 id="dx-seminars-heading" className="hb-dx-h2">過去開催のセミナーとイベント</h2>
            <p className="hb-dx-lead">DX 推進・生成 AI 活用・会計事務所運営など、テーマ別に企画してきたセミナーの開催情報です。今後のスケジュールは <a href={`${HB_BASE}/news/`} style={{color:hbcp.blue, textDecoration:'underline'}}>お知らせ一覧</a> をご覧ください。</p>
            <div className="hb-dx-sem-list">
              {SEMINARS.map(s => (
                <a key={s.url} href={s.url} className="hb-dx-sem-row">
                  <div className="hb-dx-sem-date">{s.date}</div>
                  <div className="hb-dx-sem-mode">{s.mode}</div>
                  <div className="hb-dx-sem-body">
                    <span className="hb-dx-sem-title">{s.title}</span>
                    <span className="hb-dx-sem-theme">{s.theme}</span>
                  </div>
                  <span className="hb-dx-sem-arrow" aria-hidden="true">→</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ===== Blog 動線 ===== */}
        <section style={{padding:'96px 32px', background:hbcp.paper}} aria-labelledby="dx-editorial-heading">
          <div style={{maxWidth:1280, margin:'0 auto'}} className="hb-dx-blog-grid">
            <div>
              <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', color:hbcp.blue, marginBottom:14}}>● EDITORIAL</div>
              <h2 id="dx-editorial-heading" style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(28px, 3.4vw, 40px)', lineHeight:1.22, letterSpacing:'.04em', margin:'0 0 18px'}}>
                ブログにて公開中
              </h2>
              <p style={{fontSize:15, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 22px', maxWidth:560}}>
                kintone / Salesforce / freee / バクラク / 生成 AI / BI ツール選定 ── 実際の導入現場で得た知見を、編集部が記事として継続発信中。サービス選定や運用設計の判断材料としてご活用ください。
              </p>
              <div style={{display:'flex', flexWrap:'wrap', gap:12}}>
                <a href={`${HB_BASE}/blog/`} style={{padding:'14px 26px', background:hbcp.ink, color:'#fff', textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:700}}>
                  ブログ記事を読む <span style={{fontFamily:fontEN}}>→</span>
                </a>
                <a href={`${HB_BASE}/blog-category/dx/`} style={{padding:'14px 26px', background:'transparent', color:hbcp.ink, border:`1px solid ${hbcp.ink}`, textDecoration:'none', fontFamily:fontJP, fontSize:14, fontWeight:600}}>
                  DX カテゴリを見る <span style={{fontFamily:fontEN}}>↗</span>
                </a>
              </div>
            </div>
            <div style={{display:'grid', gap:12, fontSize:13.5, fontFamily:fontJP}}>
              {BLOG_TEASERS.map(b => (
                <a key={b.tag} href={`${HB_BASE}/blog-category/dx/`} style={{display:'grid', gridTemplateColumns:'80px 1fr auto', gap:14, alignItems:'center', padding:'14px 18px', background:hbcp.paper, border:`1px solid ${hbcp.line}`, textDecoration:'none', color:hbcp.ink}}>
                  <span style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.24em', color:hbcp.blue, fontWeight:700, textTransform:'uppercase'}}>{b.tag}</span>
                  <span style={{lineHeight:1.5}}>{b.txt}</span>
                  <span style={{fontFamily:fontEN, color:hbcp.inkLight}} aria-hidden="true">→</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ===== End CTA ===== */}
        <section style={{padding:'96px 32px', background:hbcp.blue, color:'#fff', position:'relative', overflow:'hidden'}} aria-labelledby="dx-contact-heading">
          <svg style={{position:'absolute', top:'50%', right:-200, transform:'translateY(-50%)', width:560, height:560, opacity:.18}} viewBox="0 0 560 560" aria-hidden="true" focusable="false">
            {[...Array(12)].map((_,i)=>(<circle key={i} cx="280" cy="280" r={30+i*20} fill="none" stroke="#fff" strokeWidth=".7"/>))}
          </svg>
          <div style={{position:'relative', maxWidth:1280, margin:'0 auto'}} className="hb-dx-cta-grid">
            <div>
              <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', opacity:.85, marginBottom:18}}>● CONTACT — まずは30分、話してみませんか</div>
              <h2 id="dx-contact-heading" style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(32px, 4.5vw, 56px)', lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 24px'}}>
                お気軽にご相談ください
              </h2>
              <p style={{fontSize:15, lineHeight:1.95, opacity:.9, margin:0, maxWidth:560}}>
                CRM 統合・会計連携・BI 基盤・AI 導入・既存システム刷新 ── テーマによって難易度や所要期間は大きく変わります。「うちの場合いくらでどう進むのか」を、専門家が 30 分・無料で具体的に答えます。
              </p>
            </div>
            <div style={{display:'grid', gap:14}}>
              <a href={`${HB_BASE}/contact/?type=ax-dx`} style={{padding:'18px 28px', background:'#fff', color:hbcp.blue, textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:700, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>無料相談を予約する</span>
                <span style={{fontFamily:fontEN}} aria-hidden="true">→</span>
              </a>
              <a href={`${HB_BASE}/document-request`} style={{padding:'18px 28px', background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,.6)', textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:600, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>資料請求をする</span>
                <span style={{fontFamily:fontEN}} aria-hidden="true">↗</span>
              </a>
              <a href={`${HB_BASE}/achievements`} style={{padding:'18px 28px', background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,.6)', textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:600, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>導入事例を見る</span>
                <span style={{fontFamily:fontEN}} aria-hidden="true">↗</span>
              </a>
            </div>
          </div>
        </section>
      </HBLayout>
    );
  }

  Object.assign(window, { HatenaDxPage });
})();
